import { render, staticRenderFns } from "./CardLoader.vue?vue&type=template&id=01403590&"
import script from "./CardLoader.vue?vue&type=script&lang=js&"
export * from "./CardLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports